import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

interface DirtyWorkContextValue {
  addData: (type: string, items: Array<{ id: string; [key: string]: any }>) => void
  mapData: (type: string, items: Array<{ id: string; [key: string]: any }>) => Array<{ id: string; [key: string]: any }>
}

const SharedDirtyWorkContext = createContext<DirtyWorkContextValue>({
  addData: (_type: string, _items: Array<{ id: string; [key: string]: any }>) => {},
  mapData: (_type: string, items: Array<{ id: string; [key: string]: any }>) => items,
})

interface DirtyWorkDataProviderProps {
  children: React.ReactNode
}

export const DirtyWorkDataProvider = ({ children }: DirtyWorkDataProviderProps) => {
  const [data, setData] = useState<{ [type: string]: { [id: string]: any } }>(() => ({}))

  const addData = useCallback((type: string, items: Array<{ id: string; [key: string]: any }>) => {
    setData((oldValue) => {
      const oldRecord = oldValue[type] ?? {}
      const newRecord = { ...oldRecord }
      for (const item of items) {
        newRecord[item.id] = item
      }
      return { ...oldValue, [type]: newRecord }
    })
  }, [])

  const mapData = useCallback(
    (type: string, items: Array<{ id: string; [key: string]: any }>) => {
      if (data[type] == null) {
        return items
      }

      const record = data[type]

      return items.map((i) => {
        if (record[i.id]) {
          return record[i.id]
        }
        return i
      })
    },
    [data]
  )

  const value = useMemo(
    () => ({
      addData,
      mapData,
    }),
    [addData, mapData]
  )

  return <SharedDirtyWorkContext.Provider value={value}>{children}</SharedDirtyWorkContext.Provider>
}

export const useSharedCache = () => {
  const { addData, mapData } = useContext(SharedDirtyWorkContext)

  const addDirtyData = addData

  const useMappedData = (type: string, items: Array<{ id: string; [key: string]: any }>) => {
    return useMemo(() => {
      return mapData(type, items)
      // FUCK eslint, ctx really changes and cause update!
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapData, items, type])
  }

  return { addDirtyData, useMappedData }
}
